import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BasePricingDetails } from './BasePricingDetails';

export class PeriodicInstallmentPricingDetails extends BasePricingDetails {
  readonly amountToBePaid: number;
  readonly amountToBePaidInLeastSubunit: number;
  readonly downPaymentAmountToBePaid: number;
  readonly downPaymentAmountToBePaidInLeastSubunit: number;
  readonly principalAmountToBePaid: number;
  readonly principalAmountToBePaidInLeastSubunit: number;
  readonly minimumAmountToBePaid: number;
  readonly minimumAmountToBePaidInLeastSubunit: number;
  readonly installmentPricingConfigDetails: {
    config_id: string;
    no_of_installments: number;
    interval_type: 'MONTHS';
    interval_value: number;
    interest_amount_in_least_subunit: number;
  }[];

  constructor(productDetails: GetProductDetailsResponseType) {
    super(productDetails);

    const periodicDetails =
      productDetails.product_purchase_details_for_user.pricing_details
        .periodic_installment_details;
    const periodicConfigs =
      productDetails.product_details.installment_pricing_details
        .periodic_installment_pricing_configs;

    this.downPaymentAmountToBePaid =
      periodicDetails.down_payment_amount_to_be_paid || 0;
    this.downPaymentAmountToBePaidInLeastSubunit =
      periodicDetails.down_payment_amount_to_be_paid_in_least_subunit || 0;
    this.principalAmountToBePaid =
      periodicDetails.principal_amount_to_be_paid || 0;
    this.principalAmountToBePaidInLeastSubunit =
      periodicDetails.principal_amount_to_be_paid_in_least_subunit || 0;
    this.amountToBePaid = this.principalAmountToBePaid;
    this.amountToBePaidInLeastSubunit =
      this.principalAmountToBePaidInLeastSubunit;
    this.minimumAmountToBePaid = this.downPaymentAmountToBePaid;
    this.minimumAmountToBePaidInLeastSubunit =
      this.downPaymentAmountToBePaidInLeastSubunit;
    this.installmentPricingConfigDetails = periodicConfigs || [];
  }

  get isEligibleForFreeProduct(): boolean {
    return this.amountToBePaid === 0;
  }
}
